// AUTO-GENERATED. DO NOT EDIT.
// Source: scripts/i18n/generate_i18n_catalogs.mjs

export const commonErrorApiCodeEdu = {
  eduPlatformApplicationNotFound: "EDU 平台应用 {app_key} 不存在",
  eduPlatformDataContractInvalid: "EDU 平台数据合同无效：{field_name}，{reason}",
} as const;
